import { useRef, useState } from "react";

/**
 * Hook to manage the interaction state of authentication pages
 * Tracks whether the user has interacted with the form to trigger layout changes
 */
export const useAuthPageInteraction = () => {
  const [hasBeenInteracted, setHasBeenInteracted] = useState(false);
  const inputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

  const handleFormFocus = (e: React.MouseEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    inputRef.current = e.target as HTMLInputElement | HTMLTextAreaElement;

    inputRef.current?.blur();
    setHasBeenInteracted(true);

    setTimeout(() => {
      inputRef.current?.focus();
    }, 500);
  };

  return {
    hasBeenInteracted,
    handleFormFocus,
  };
};
